<template>
  <div>
    <PageTitle title="Create Room" :backBtn="true" :showLoading="isLoading" />
    <v-container fluid class="lighten-12">
      <ValidationObserver ref="observer">
        <!-- Page Title -->
        <!-- <PageTitle title="Create Product" :backBtn="true" /> -->
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-card-title>General</v-card-title>
                  <v-container>
                    <v-row>
                      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="Room name"
                          rules="required|no_spaces_only"
                          vid="name"
                        >
                          <v-text-field
                            outlined
                            v-model="Room.name"
                            :error-messages="errors"
                            dense
                            hide-details="auto"
                            label="Room Name"
                            @blur="Room.name = Room.name.trim()"
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <!-- <v-flex class="mb-2 font-weight-medium bg-light pa-3">Brand</v-flex> -->
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="Floor"
                          dense
                          rules="required"
                        >
                          <v-autocomplete
                            v-model="Room.floor_id"
                            item-text="name"
                            item-value="id"
                            :items="roomFloors"
                            :error-messages="errors"
                            :loading="loadingBrand"
                            outlined
                            dense
                            hide-details="auto"
                            label="Floor"
                          ></v-autocomplete>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <ValidationProvider
                          v-slot="{ errors }"
                          :rules="{ regex: /^[+,-,0-9]*[+,-,0-9]*$/ }"
                        >
                          <v-text-field
                            outlined
                            v-model="Room.phone_expression"
                            dense
                            :error-messages="errors"
                            hide-details="auto"
                            maxlength="13"
                            label="PhoneNumber"
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <v-checkbox
                          v-model="nonSmoking"
                          label="Non-Smoking"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                    <!-- <v-row>
                      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="Room Type"
                          dense
                          rules="required"
                        >
                          <v-autocomplete
                            v-model="Room.room_type_id"
                            item-text="name"
                            item-value="id"
                            :items="roomTypes"
                            outlined
                            required
                             :error-messages="errors"
                            dense
                            hide-details="auto"
                            label="Room Type"
                          ></v-autocomplete>
                        </ValidationProvider>
                      </v-col>
                     
                    </v-row> -->
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-card-title>Room Type Details</v-card-title>

                  <v-container>
                    <v-data-table
                      v-if="isLoadingAmount"
                      :headers="columns"
                      :items="roomTypes"
                      hide-default-footer
                      v-model="selectedRoomTypes"
                      disable-pagination
                      show-select
                      fixed-header
                       height="300"
                      class="elevation-1"
                    >
                      <template v-slot:[`item.name`]="{ item }">
                        <v-autocomplete
                          v-model="item.id"
                          item-text="name"
                          item-value="id"
                          :items="roomTypes"
                          :error-messages="errors"
                          outlined
                          required
                          dense
                          disabled
                          hide-details="auto"
                          label="Room Type"
                        ></v-autocomplete>
                      </template>
                      <template v-slot:[`item.amount`]="{ item }">
                        <!-- <ValidationProvider
                          v-slot="{ error }"
                          :rules="{ regex: /^[+,-,0-9]*[+,-,0-9]*$/ }"
                        > -->

                        <v-text-field
                          outlined
                          @input="RoomTypeAmountChange(item)"
                          v-model="item.amount_of_roomtype"
                          :error-messages="item.RoomTypeAmountError"
                          dense
                          type="number"
                          hide-details="auto"
                          label="amount"
                          :min="0"
                        ></v-text-field>
                        <!-- </ValidationProvider> -->
                      </template>
                    </v-data-table>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-card-title>Note</v-card-title>

                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12" lg="12">
                        <v-textarea
                          rows="3"
                          outlined
                          v-model="Room.remarks"
                          hide-details
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
            <v-row>
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <v-card>
                  <v-container>
                    <v-row>
                      <v-col cols="12" class="pb-0">
                        <v-flex class="pt-0 pa-1">
                          <FileUpload
                            ref="fileUpload"
                            title="Image"
                            :multiple="true"
                            v-model="selectedImages"
                            size="10000"
                            :types="['jpeg', 'png', 'jpg']"
                            :showPreview="true"
                            :camera="true"
                            accept="image/x-png,image/gif,image/jpeg"
                          />
                        </v-flex>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-col cols="12" class="text-right pa-0">
          <v-btn
            depressed
            small
            class="ml-1 text-white btn_medium"
            @click="clear"
            >Clear</v-btn
          >
          <v-btn
            depressed
            small
            class="text-white btn_blue btn_medium w-100"
            @click="submit"
            >Submit</v-btn
          >
        </v-col>
      </ValidationObserver>
    </v-container>
  </div>
</template>
<script>
// import RoomProperty from "./RoomProperty.vue";
import { required, email, max, regex } from "vee-validate/dist/rules";
import FileUpload from "@/components/base/FileUpload";
import { Room } from "../../../models/Room";
import { ProductEntity } from "../../../models/EntityModels/ProductEntity";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import { ProductBrand } from "../../../models/ProductBrand";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import axios from "@/plugins/axios";
setInteractionMode("eager");

// Mixins
// import Categories from "@/mixins/Categories";

extend("required", {
  ...required,
  message: "{_field_} is required",
});

extend("no_spaces_only", {
  validate: (value) => {
    return value && value.trim().length > 0;
  },
  message: "{_field_} cannot be empty or spaces only",
});

extend("max", {
  ...max,
  message: "{_field_} may not be greater than {length} characters",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});
extend("regex", {
  ...regex,
  message: "This entry can only contain numbers.",
});

export default {
  // mixins: [Categories],
  components: {
    ValidationProvider,
    ValidationObserver,
    Treeselect,
    FileUpload,
    // RoomProperty,
  },
  computed: {
    // UI label is "Non-Smoking" but API field is `is_smoking` (true means smoking allowed)
    nonSmoking: {
      get() {
        return !this.Room.is_smoking;
      },
      set(val) {
        this.Room.is_smoking = !val;
      },
    },
  },
  data: () => ({
    roomFloors: [],
    roomTypes: [],
    RoomTypeAmountError: [],
    isLoading: false,
    isLoadingAmount: true,
    loadingBrand: false,
    bedTypes: [],
    Room: new Room(),
    errors: [],

    messages: [],

    selectedRoomTypes: [],
    selectedImages: [],
    suppliers: [],
    selectedSuppliers: [],
    columns: [
      {
        text: "Room Types",
        value: "name",
        show: true,
        disabled: true,
      },
      {
        text: "Amounts",
        value: "amount",
        align: "left",
        show: true,
        disabled: true,
      },
    ],
  }),
  created() {
    this.GetFloors();
    this.GetRoomTypes();
    // this.GetBedTypes();
  },
  methods: {
    RoomTypeAmountChange(item) {
      this.isLoadingAmount = false;
      item.amount_of_roomtype = item.amount_of_roomtype;
      //  setTimeout(() => {
      this.isLoadingAmount = true;
      // }, 10);
    },
    async submit() {
      this.clickSubmit = true;
      const isValid = await this.$refs.observer.validate();

      if (this.selectedRoomTypes.length === 0) {
        this.$toast.error("Please select at least one Room Type");
        return;
      }

      let error = false;
      let self = this;
      self.selectedRoomTypes.map((p) => {
        if (p.amount_of_roomtype <= 0) {
          this.isLoadingAmount = false;
          // p.RoomTypeAmountError = [];
          p.RoomTypeAmountError = "Amount should be greater than 0";
          setTimeout(() => {
            this.isLoadingAmount = true;
          }, 10);
          error = true;
        }
      });
      if (isValid && !error) {
        this.AdddRoom();
      }
    },

    clear() {
      // this.Supplier = new Supplier();
      this.isClickedClear = false;
      this.isClickedClear = true;
      // this.Product = [];
      this.Room = new Room();
      this.selectedImages = [];
      this.selectedRoomTypes = [];
      this.roomTypes.map((p) => {
        return (p.amount_of_roomtype = 0), (p.RoomTypeAmountError = []);
      });
      // this.$refs.unitComponent.resetUnits();
      this.$refs.fileUpload.removeItem(0);
      this.$refs.observer.reset();
    },
    AdddRoom() {
      this.isLoading = true;
      this.Room.types = [];
      this.selectedRoomTypes.map((p) => {
        this.Room.types.push({
          room_type_id: p.id,
          amount: p.amount_of_roomtype,
        });
      });
      axios
        .post(`hms/rooms`, this.Room.toRequestModel())
        .then(async (res) => {
          this.succeeed = true;
          if (this.selectedImages) {
            await this.UploadRoomImage(res.data.id)
              .then(() => {
                this.isDisabledSubmit = false;
                this.isLoading = false;
              })
              .catch(() => {
                this.$toast.error("Room image uploading failed");
                this.isDisabledSubmit = false;
                this.isLoading = false;
              });
          }
          this.$toast.success("Room created  successfully");
          this.$router.push("/room");
        })
        .catch((err) => {
          this.isLoading = false;

          this.$refs.observer.setErrors(err.response.data.error);
          this.$toast.error("Room create failed");

          this.messages = err.data.title;
          // this.messages.push(err.data.title);
          this.isDisabledSubmit = false;
        });
    },
    async UploadRoomImage(productId) {
      let fromData = new FormData();
      console.log("Imgae", this.selectedImages);
      for (var i = 0; i < this.selectedImages.length; i++) {
        fromData.append("images", this.selectedImages[i]);
      }
      axios
        .post(`hms/rooms/${productId}/image-upload`, fromData)
        .then((res) => {})
        .catch((err) => {});
    },
    GetFloors() {
      axios
        .get(`hms/floors?status=active&size=1000`)
        .then((res) => {
          console.log("Total floors:", res.data.data.length);
          this.roomFloors = res.data.data;
        })
        .catch((err) => {});
    },
    GetRoomTypes() {
      axios
        .get(`hms/room-types?size=1000`)
        .then((res) => {
          console.log("Total room type:", res.data.data.length);
          this.roomTypes = res.data.data;
          this.roomTypes.map((p) => {
            return (p.amount_of_roomtype = 0), (p.RoomTypeAmountError = []);
          });
        })
        .catch((err) => {});
    },

    //     GetBedTypes() {
    //   axios
    //     .get(`hms/bed-types`)
    //     .then((res) => {

    //       this.bedTypes = res.data.data;
    //     })
    //     .catch((err) => {});
    // },
  },

  watch: {},
};
</script>
